var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.928 0H2.315a1.082 1.082 0 100 2.164h20.613a1.082 1.082 0 000-2.164zM23.8 3.969H1.443A1.442 1.442 0 000 5.41v15.146A1.442 1.442 0 001.442 22h22.359a1.442 1.442 0 001.442-1.443V5.411a1.443 1.443 0 00-1.442-1.442zM5.77 6.854a2.164 2.164 0 110 4.327 2.164 2.164 0 010-4.327zm1.803 12.08H4.688a.901.901 0 010-1.803h2.885a.901.901 0 010 1.803zm6.491 0h-2.885a.902.902 0 010-1.803h2.885a.902.902 0 010 1.803zm6.491 0H17.67a.902.902 0 010-1.803h2.885a.902.902 0 010 1.803zm0-8.655H11.18a.902.902 0 010-1.803h9.376a.902.902 0 010 1.803z",
    fill: "#040039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.12a5da1be0f080b2cb926dae603d1bcc.svg";
export { ForwardRef as ReactComponent };